import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-623c64c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "chat__content" }
const _hoisted_3 = {
  key: 0,
  class: "center chat__message-time mt--10 mb--10"
}
const _hoisted_4 = {
  key: 0,
  class: "chat__person-avatar"
}
const _hoisted_5 = { class: "chat__messages" }
const _hoisted_6 = { class: "chat__message" }
const _hoisted_7 = { class: "chat__message-content" }
const _hoisted_8 = { class: "chat__message-time" }

import { MessageType } from '@/api/chat/types';
import { computed, getCurrentInstance, onMounted, ref, watch } from 'vue';
import { useUserStore } from '@/store/modules/user';
import { ComponentInternalInstance } from '@vue/runtime-core';

type PreparedMessageType = {
  isNewDate?: boolean;
} & MessageType;


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatComponent',
  props: {
    withAva: { type: Boolean, default: true },
    messages: {}
  },
  setup(__props: any) {

const props = __props;
const instance: ComponentInternalInstance | null = getCurrentInstance();
const uuid = ref(instance?.uid);

const getRuDate = (date: string): string => {
  return new Date(date).toLocaleString('ru', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

const preparedMessages = computed((): PreparedMessageType[][] => {
  if (props.messages) {
    let preparedMessages: PreparedMessageType[][] = [];
    let index = 0;

    props.messages.forEach((el, i) => {
      if (i === 0) {
        preparedMessages.push([{ ...el, isNewDate: true }]);
      } else {
        if (
          props.messages[i - 1].user_id === el.user_id &&
          new Date(props.messages[i - 1].created_at).toDateString() ===
            new Date(el.created_at).toDateString()
        ) {
          preparedMessages[0].unshift(el);
        } else {
          index++;
          preparedMessages.unshift([
            {
              ...el,
              isNewDate:
                new Date(props.messages[i - 1].created_at).toDateString() !==
                new Date(el.created_at).toDateString(),
            },
          ]);
        }
      }
    });

    return preparedMessages;
  }

  return [];
});

const scrollToBottom = () => {
  let div = document.getElementById(`chat${uuid.value}`);

  if (div) {
    div.scrollTop = div.scrollHeight;
  }
};

onMounted(() => {
  scrollToBottom();
});

watch(
  () => props.messages,
  () => {
    setTimeout(() => {
      scrollToBottom();
    }, 100);
  },
);

return (_ctx: any,_cache: any) => {
  const _component_base_image = _resolveComponent("base-image")!

  return (_openBlock(), _createElementBlock("div", {
    id: `chat${uuid.value}`,
    class: "chat"
  }, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(preparedMessages.value, (group) => {
        return (_openBlock(), _createElementBlock("div", null, [
          (group[group.length - 1].isNewDate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(getRuDate(group[group.length - 1].created_at)), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass([{
            'chat__item--responder': group[0].user_id === _unref(useUserStore)().user?.id,
          }, "chat__item"])
          }, [
            (_ctx.withAva)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_base_image, {
                    src: require('@/assets/img/profile/avatar.png'),
                    contain: "",
                    height: "25",
                    name: "ava",
                    width: "25"
                  }, null, 8, ["src"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (message) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(message.message), 1),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(new Date(message.created_at).toLocaleTimeString([], {
                    hour: '2-digit',
                    minute: '2-digit',
                  })), 1)
                ]))
              }), 256))
            ])
          ], 2)
        ]))
      }), 256))
    ])
  ], 8, _hoisted_1))
}
}

})